export const server = {
    start: () => console.log('Insight server started'),
};
